module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Table.js"));
	}, "Table");
}